import React from 'react';
import { Box, Typography } from '@mui/material';

const FormField = ({ label, children, required = false, error, helperText }) => (
  <Box sx={{ mb: 4 }}>
    <Typography 
      variant="subtitle1" 
      gutterBottom 
      sx={{ 
        fontWeight: 600, 
        color: "text.primary",
        display: "flex",
        alignItems: "center",
        gap: 0.5,
      }}
    >
      {label}
      {required && <Typography component="span" color="error">*</Typography>}
    </Typography>
    {children}
    {error && (
      <Typography color="error" variant="caption" sx={{ display: "block", mt: 0.5, mb: 2 }}>
        {helperText}
      </Typography>
    )}
  </Box>
);

export default FormField; 